import { Box, Slider } from '@mui/material'
import { useState } from 'react'
import '../../../Style/Pulse.css'

const PulseExample = ({}) => {
  const [clicked, setClicked] = useState(false)
  return (
    <>
      <Box
        sx={{
          width: '65%',
          justifyContent: 'center',
          margin: '16px auto',
          display: { md: 'flex', xs: 'none' }
        }}
      >
        <Slider
          onChangeCommitted={(e, _value) => {
            if (
              e.type === 'mouseup' ||
              (e.type === 'keydown' && e.key === 'Enter')
            ) {
              setClicked(true)
            }
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              setClicked(true)
            }

            if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
              setClicked(true)
            }
          }}
          className={clicked ? 'pulse-slider-clicked' : ''}
          sx={{
            mb: 4,
            '& .MuiSlider-mark': {
              background: theme => theme.palette.primary.main
            },
            '& .MuiSlider-markLabel': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              padding: '2px 8px',
              borderRadius: '16px',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              marginTop: 1,
              lineHeight: 2,
              '&:hover': {
                opacity: '0.9'
              }
            }
          }}
          defaultValue={-1}
          valueLabelDisplay='off'
          marks={[
            'Strongly Disagree',
            'Disagree',
            'Neutral',
            'Agree',
            'Strongly Agree'
          ].map((value, index) => ({
            value: index,
            label: value
          }))}
          step={null}
          min={0}
          max={
            [
              'Strongly Disagree',
              'Disagree',
              'Neutral',
              'Agree',
              'Strongly Agree'
            ].length - 1
          }
        />
      </Box>
      <Box
        sx={{
          margin: '32px auto 16px auto',
          height: '300px',
          display: { md: 'none', xs: 'flex' }
        }}
      >
        <Slider
          onChangeCommitted={(e, _value) => {
            if (
              e.type === 'mouseup' ||
              (e.type === 'keydown' && e.key === 'Enter')
            ) {
              setClicked(true)
            }
          }}
          orientation='vertical'
          className={clicked ? 'pulse-slider-clicked' : ''}
          sx={{
            mb: 4,
            '& .MuiSlider-mark': {
              background: theme => theme.palette.primary.main
            },
            '& .MuiSlider-markLabel': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              padding: '2px 8px',
              borderRadius: '16px',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              marginTop: 1,
              lineHeight: 2,
              '&:hover': {
                opacity: '0.9'
              }
            }
          }}
          defaultValue={-1}
          valueLabelDisplay='off'
          marks={[
            'Strongly Disagree',
            'Disagree',
            'Neutral',
            'Agree',
            'Strongly Agree'
          ].map((value, index) => ({
            value: index,
            label: value
          }))}
          step={null}
          min={0}
          max={
            [
              'Strongly Disagree',
              'Disagree',
              'Neutral',
              'Agree',
              'Strongly Agree'
            ].length - 1
          }
        />
      </Box>
    </>
  )
}

export default PulseExample
